export var MARK_VARIANTS = {
    normal: {
        outerRadius: 10,
        innerRadius: 4,
        strokeWidth: 4,
    },
    small: {
        outerRadius: 7,
        innerRadius: 3,
        strokeWidth: 3,
    },
};
var MARK_TRESHOLD = 35;
export var calculateMarkPosition = function (_a) {
    var layout = _a.layout, x = _a.x, y = _a.y, width = _a.width, height = _a.height, inPositiveCartesianQuadrant = _a.inPositiveCartesianQuadrant;
    if (layout === 'vertical') {
        return {
            x: x + width * 0.5,
            y: inPositiveCartesianQuadrant ? y : y + height,
        };
    }
    return {
        x: inPositiveCartesianQuadrant ? x + width : x,
        y: y + height * 0.5,
    };
};
export var setMarkSize = function (_a) {
    var layout = _a.layout, height = _a.height, width = _a.width;
    if (layout === 'vertical') {
        return width < MARK_TRESHOLD
            ? MARK_VARIANTS['small']
            : MARK_VARIANTS['normal'];
    }
    return height < MARK_TRESHOLD
        ? MARK_VARIANTS['small']
        : MARK_VARIANTS['normal'];
};
